namespace GeniuzPOS.Member {
    export interface MbReport01_DtRow {
        Id?: string;
        ShopId?: string;
        ShopName?: string;
        DocDate?: string;
        DocNo?: string;
        MbId?: string;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        AllItemCharge?: number;
        VatOfCharge?: number;
        ReCash?: number;
        ReCreditCd?: number;
        ReDebitCd?: number;
        ReCoupon?: number;
        ReCashCard?: number;
        RePoint?: number;
        ReOther?: number;
        ReQr?: number;
        ReCurrency?: number;
        PluDtList?: MbReport_01_Dt_Row[];
    }

    export namespace MbReport01_DtRow {
        export const idProperty = 'DocNo';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'Member.MbReport01_Dt';
        export const deletePermission = '3Member:สถานะสมาชิก:View';
        export const insertPermission = '3Member:สถานะสมาชิก:View';
        export const readPermission = '3Member:สถานะสมาชิก:View';
        export const updatePermission = '3Member:สถานะสมาชิก:View';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            ShopName = "ShopName",
            DocDate = "DocDate",
            DocNo = "DocNo",
            MbId = "MbId",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            AllItemCharge = "AllItemCharge",
            VatOfCharge = "VatOfCharge",
            ReCash = "ReCash",
            ReCreditCd = "ReCreditCd",
            ReDebitCd = "ReDebitCd",
            ReCoupon = "ReCoupon",
            ReCashCard = "ReCashCard",
            RePoint = "RePoint",
            ReOther = "ReOther",
            ReQr = "ReQr",
            ReCurrency = "ReCurrency",
            PluDtList = "PluDtList"
        }
    }
}
